/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedDescription_buyPage = {
    readonly description: string | null;
    readonly " $refType": "BuySharedDescription_buyPage";
};
export type BuySharedDescription_buyPage$data = BuySharedDescription_buyPage;
export type BuySharedDescription_buyPage$key = {
    readonly " $data"?: BuySharedDescription_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedDescription_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedDescription_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '116f3079323f4cfbbb322b1d436e66a6';
export default node;
